import React from 'react';
import { Typography } from '@mui/material';
import StyledLink from '#component/general/styled-link';

const LogInlineLink = ({ to, text, isMobile }) => (
  isMobile ? (
    <>
      &nbsp;
      <Typography display="inline" fontWeight={500}>
        {text}
      </Typography>
      &nbsp;
    </>
  ) : (
    <>
      &nbsp;
      <StyledLink to={to}>
        &quot;
        {text}
        &quot;
      </StyledLink>
      &nbsp;
    </>
  )
);

export default LogInlineLink;
